var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "150px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "原仪表名称",
                        disabled: "",
                        prop: "shareMeterNameOld"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.childData.shareMeterNameOld,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "shareMeterNameOld", $$v)
                          },
                          expression: "childData.shareMeterNameOld"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "仪表类型", prop: "meterId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          staticStyle: { width: "300px" },
                          attrs: {
                            disabled: "",
                            filterable: "",
                            placeholder: "请选择仪表类型"
                          },
                          model: {
                            value: _vm.childData.meterId,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "meterId", $$v)
                            },
                            expression: "childData.meterId"
                          }
                        },
                        _vm._l(_vm.meterTypeList, function(item) {
                          return _c("el-option", {
                            key: item.meterId,
                            attrs: {
                              label: item.meterName,
                              value: parseInt(item.meterId)
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "原仪表上次读数", prop: "lastReadNum" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.childData.lastReadNum,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "lastReadNum", $$v)
                          },
                          expression: "childData.lastReadNum"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "原仪表上次读数日期",
                        prop: "lastReadDate"
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "300px" },
                        attrs: {
                          disabled: "",
                          type: "date",
                          placeholder: "请选择更换日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.childData.lastReadDate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "lastReadDate", $$v)
                          },
                          expression: "childData.lastReadDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "原仪表更换时读数",
                        prop: "changeReadNumber"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.changeReadNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "changeReadNumber", $$v)
                          },
                          expression: "childData.changeReadNumber"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "更换日期", prop: "readDate" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "300px" },
                        attrs: {
                          type: "date",
                          placeholder: "请选择更换日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.childData.readDate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "readDate", $$v)
                          },
                          expression: "childData.readDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "新仪表名称",
                        disabled: "",
                        prop: "shareMeterName"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.shareMeterName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "shareMeterName", $$v)
                          },
                          expression: "childData.shareMeterName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "新仪表初始读数", prop: "currentRead" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.currentRead,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "currentRead", $$v)
                          },
                          expression: "childData.currentRead"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "损耗率" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.meterWastageRate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "meterWastageRate", $$v)
                          },
                          expression: "childData.meterWastageRate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "倍率", prop: "meterPower" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.meterPower,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "meterPower", $$v)
                          },
                          expression: "childData.meterPower"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }